var styles = {"accordionInlineWrapper":"VBG__DS__accordion-inline-module__Q28uk"};

export { styles as default };
